import {
  AgencyDnsSettingStatus,
  ApplicationDnsSetting,
  WhitelabelSubjectApplication,
} from 'models/CustomDomains';

export const CUSTOM_DOMAINS_HELP_URL =
  'https://help.hostfully.com/en/articles/3049073-white-label-your-hostfully-sites';

// Domain with at least two labels; letters/digits/hyphens, no leading/trailing hyphen
export const DOMAIN_PATTERN =
  /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/;

// Mirrors the legacy agency.js restriction on hostfully-owned domains
export const NOT_ALLOWED_DOMAINS_PATTERN = /(book|platform)\.hostfully/;

export const normalizeDomain = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '');

export const hasLegacySettings = (settings: ApplicationDnsSetting[]): boolean =>
  settings.some(({ status }) => status === AgencyDnsSettingStatus.LEGACY);

const postToLegacyFrame = (message: Record<string, unknown>) => {
  document
    .querySelector<HTMLIFrameElement>('iframe#legacy-page-frame')
    ?.contentWindow?.postMessage(message, '*');
};

// the jsp keeps its value when a domain is empty, so cancellations are explicit
export const postCustomDomainsUpdatedToLegacyFrame = (
  settings: ApplicationDnsSetting[],
  clearedApplications: WhitelabelSubjectApplication[] = [],
) => {
  postToLegacyFrame({
    customDomainsUpdated: {
      pmpDomain:
        settings.find(
          ({ application }) =>
            application === WhitelabelSubjectApplication.PLATFORM,
        )?.domain ?? '',
      dbsDomain:
        settings.find(
          ({ application }) => application === WhitelabelSubjectApplication.DBS,
        )?.domain ?? '',
      // drives the jsp button state and the migration banner
      shouldMigrate: hasLegacySettings(settings),
      clearedApplications,
    },
  });
};

// only sent when something changed, so the jsp can reveal what the customer just configured
export const postCustomDomainsModalClosedToLegacyFrame = () => {
  postToLegacyFrame({ customDomainsModalClosed: true });
};
